export default {"src":"/_next/static/media/lkk.6c144a4c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};